
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/peppertype-ai",
      function () {
        return require("private-next-pages/peppertype-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/peppertype-ai"])
      });
    }
  